// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"small-hero_wrapper__v63xC","label":"small-hero_label__BIQcQ"};